<template>
  <div class="fixed inset-0 bg-slate-950">
    <div
      v-if="!iframeLoaded"
      class="absolute inset-0 z-10 flex items-center justify-center bg-slate-950"
    >
      <div class="flex items-center gap-3 text-sm text-slate-400">
        <div class="h-5 w-5 animate-spin rounded-full border-2 border-white/20 border-t-indigo-400"></div>
        正在加载编辑工作台...
      </div>
    </div>

    <iframe
      :src="workspaceUrl"
      class="absolute inset-0 h-full w-full border-0 bg-white"
      title="Mock 内容工作台"
      referrerpolicy="strict-origin-when-cross-origin"
      @load="iframeLoaded = true"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { getMockEditorWorkspaceUrl } from '@/utils/mockEditorUrl'

const route = useRoute()
const iframeLoaded = ref(false)

const paperId = computed(() => Number(route.params.paperId))
const workspaceUrl = computed(() => getMockEditorWorkspaceUrl(paperId.value))
</script>
